import { render, staticRenderFns } from "./musicHall.vue?vue&type=template&id=375b260b&scoped=true&"
import script from "./musicHall.vue?vue&type=script&lang=js&"
export * from "./musicHall.vue?vue&type=script&lang=js&"
import style0 from "./musicHall.vue?vue&type=style&index=0&id=375b260b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b260b",
  null
  
)

export default component.exports